import { XeroAccountMappingsDto } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { Model } from "@libs/models/Model.ts";

export class AccountMapping extends Model<XeroAccountMappingsDto> {
  get id() {
    return this.dto.id;
  }

  get invoiceAccountId() {
    return this.dto.invoiceAccountId;
  }

  get paymentAccountId() {
    return this.dto.paymentAccountId;
  }

  get providerId() {
    return this.dto.providerId;
  }

  get unallocatedAccountId() {
    return this.dto.unallocatedAccountId;
  }

  get targetTenantId() {
    return this.dto.targetTenantId;
  }

  get changeLog() {
    return this.dto.changeLog;
  }
}
